module.exports = __webpack_public_path__ + "img/moishop_portfolio_5_mob.623379de.png";